
export const DOCS_FIELD_MAP_SHOW = {
    'payroll': 'Nómina',
    'contract': 'Contrato',
    'model_tax':'Modelos/Impuestos',
    'certificate':'Certificado',
    'bill':'Factura',
    'other': 'Otros',
    'pending': 'Pendiente',
    'waiting_approval': 'Pendiente de aprobación',
    'approved': 'Aprobado',
    'rejected': 'Rechazado',
    'insufficient_credits': 'Saldo insuficiente',
    'lost_workflow': 'Error workflow desaparecido', 
    'error': 'Error',
    'done': 'Completado',
    'WaitForApproval': 'Esperar aprobación',
    'AskAI': 'Extracción de informacion con IA',
    'AddDocumentRepresentationToConversation': 'Añadir representación de documento a conversación',
    'CompleteConversation': 'Completar conversación con IA',
    'UploadAsInvoice': 'Subir como factura',
    'SendThroughEmail': 'Enviar por correo electrónico',
    'SendEmailWithTemplate': 'Enviar correo electrónico con plantilla',
    'LookupAndMatchInstance': 'Buscar y adjuntar registro',
    'LookupAndMatchMultipleInstances': 'Buscar y adjuntar varios registros',
    'ExtractInstanceFromRawData': 'Extraer registro previamente inyectado',
    'CreateInstanceFromContext': 'Crear registro a partir de contexto',
    'CreateInstance': 'Crear registro',
    'CreateInstancesFromList': 'Crear registros a partir de lista',
    'AddInstanceToList': 'Añadir registro a lista',
    'ModifyContext': 'Modificar registro',
    'PayrollAccounting': 'Contabilizar nómina',
    'SendDataToEndpoint': 'Enviar datos a un endpoint',
    'NotifyCounterpart': 'Notificar a la contraparte',
    'RunCommand': 'Ejecutar comando',
    'RunQuery': 'Ejecutar consulta',
    'RunWorkflow': 'Ejecutar workflow',
    'RunScript': 'Ejecutar script de python',
    'SplitFile': 'Separar pàginas archivo',
    'DeleteContextInstance': 'Eliminar registro',
    'ExtractTextFromDocument': 'Extraer texto del documento'
};

export function updateFrontendData(frontend, data, count) {
    frontend.other_documents = data
    // frontend.other_documents = frontend.other_documents.slice(frontend.offset, frontend.offset + frontend.limit)
    frontend.selectedItems = []
    frontend.totalItems = count
    if(frontend.totalItems > 0){
        frontend.showSelect = true
    }
    frontend.selectAllItems = false;
    frontend.calculateTableHeight();
    frontend.drawer = false;
}

export function obtainFilters(frontend) {
    frontend.filters=[]
    frontend.filters.push({company_id: frontend.companydb_id});
    if(frontend.filter_doc_name)
        frontend.filters.push({original_file_name: frontend.filter_doc_name});
    if(frontend.filter_doc_type)
        frontend.filters.push({type: frontend.filter_doc_type});
    if(frontend.filter_date_from)
        frontend.filters.push({date_from: frontend.filter_date_from});
    if(frontend.filter_date_to)
        frontend.filters.push({date_to: frontend.filter_date_to});
    if(frontend.sortBy && frontend.sortBy != '')
        frontend.filters.push({order_by: frontend.sortBy})
    if(frontend.filter_need_approval)
        frontend.filters.push({need_approval: frontend.filter_need_approval})
}

export function get_error_accounting_message(error, literals, asHtml:boolean) {

    if (!error || typeof error !== 'string') return null; 

    if (error.includes('FiscalAccountDoesNotExist')){
        return 'La cuenta del '+ literals.t +' no existe en el programa contable';
    } else if (error.includes('EjercicioCerrado')){
        return 'El ejercicio está cerrado en el programa contable';
    } else if (error.includes('AccountDoesNotExist')){
        return 'Alguna de las cuentas del asiento no existe en el programa contable';
    } else if(error.includes('Faltan las siguientes cuentas en el destino:') || error.includes('Los siguientes campos no pueden estar vacíos:') ){
        return error;
    } else if (error.includes('ContanetNSTPathDoesNotExist')) {
        return 'No se ha podido encontrar la empresa en la ruta .NST';
    } else if (error.includes('Suplidos account not configured')) {
        return 'Cuenta de suplidos no configurada';
    } else if (error.includes('DatabaseError') && error.includes('Problematic key') && error.includes('CLAVEDAT') && error.includes('EJERCICIO') && error.includes('ACTIVIDAD')) {
        return 'Es posible que la actividad sea incorrecta o el ejercicio no esté disponible para esta empresa en Aplifisa Fiscal';
    } else if (error.includes('Se produjo un error en el cálculo del IVA/IGIC') && error.includes('Se ha grabado el apunte, pero debe comprobar el Tipo, la Base y el Total')) {
        return 'Contanet ha dado el siguiente error: "Se produjo un error en el cálculo del IVA/IGIC. Se ha grabado el apunte, pero debe comprobar el Tipo, la Base y el Total". Es posible que el problema sea que algún Id de los IVA/IGIC no esté bien configurado en la empresa.';
    } else if (error.includes('PermissionError: [Errno 13] Permission denied:') && error.includes('Inmatic.xlsx')){
        return "No se ha podido escribir en el fichero Excel; parece que el fichero estaba abierto. Cierre el Excel y reintente el documento."
    } else if (error.includes('Documento requiere contraseña')){
        return "No se pudo abrir el fichero, el documento requiere contraseña"
    } else if (error.includes('Por alguna razón nos ha sido imposible acceder a la empresa,')) {
        return  error;
    } else if(error.includes('Contacta con ')) {
        return  error;
    } else if (error.includes('Payment Innuva Error')) {
        return  `La factura se ha contabilizado, pero ha habido un error al crear el ${ literals.pm } en Innuva, verifique que está todo correcto.`
    } else if(error.includes('Error en la contabilización')) {
        return  error;
    } else if(error.includes('[Errno 13] Permission denied') && error.includes('xslx.py') && error.includes('zipfile.py')){
        return  "Parece ser que el Excel de carga está abierto por otro programa, cierre el fichero y vuelva a contabilizar la factura."
    } else if(error.includes('user_error')) {
        let json_msg
        let exc
        try {
            exc = false
            json_msg = JSON.parse(error.replace(/'/g, '"')) // try original method, replace ' with "
        }
        catch (e) { exc = true }
        if (exc) {
            try {
                exc = false
                json_msg=JSON.parse(error) // if exception, try parsing it raw
            }
            catch (e) { exc = true }
        }
        if (exc) {
            try { // if another exception occurred, try escaping present ", replacing unescaped ' with " and finally unescape '
                exc = false 
                let aux_error = error.replace(/"/g, '\\"')          // escape present double quotes (assume string quotes are simple ')
                aux_error = aux_error.replace(/(?<!\\)'/g, '"')     // replace all simple quotes ' with double quotes " (except those ' preceded by \, which are escaped)
                aux_error = aux_error.replace(/\\'/g, "'")          // unescape ' (replace \' with ')
                json_msg=JSON.parse(aux_error)
            }
            catch (e) { exc = true }
        }
        if (exc) {
            console.log("errors when parsing json string, return it raw")
            return error
        }

        if (!asHtml) {
            return `Por favor, revise los siguientes errores: ${json_msg.user_error.map(error => `${error}`).join('')}`
        }
        else {
            const errorsHTML = `
            <p>Por favor, revise los siguientes errores:</p>
            <ul>
                ${json_msg.user_error.map(error => `<li>${error}</li>`).join('')}
            </ul>
            `
            return  errorsHTML
        }
    }
    return null
}